import mitt from "mitt";
import type { SelectedFilters } from "@/components/viewFilter/models.ts";
import type { TitleProperties } from "@/components/sideMenu/models.ts";
import type { ObjectWithId } from "@/model/commonModels.ts";
import type { GeoJsonPoint } from "@/scripts/geoUtils.ts";

export interface ShowObervationEmitAvalanche {
  id: string;
  avalancheClass: "SINGLE_AVALANCHE" | "SEVERAL_AVALANCHE";
  userId: string | null | undefined;
  coord?: GeoJsonPoint;
  creatorSystem: string | null | undefined;
  creation: string | null | undefined;
  canWrite: boolean;
}

export interface ShowObservationEmit {
  obsIds: string[];
  aval: ShowObervationEmitAvalanche;
  aggregate: boolean;
  nested: boolean;
}

type Events = {
  showCommonLayers: { show: boolean; id?: string } | boolean;
  showLegend: boolean;
  showFilter: boolean;
  showLayer: boolean;
  layer: Record<string, unknown>;
  showObservation: ShowObservationEmit | object;
  ["save-menu-state-filters"]: void;
  ["update::filter"]: { filters: SelectedFilters };
  ["update::mapSubtitle"]: TitleProperties;
  ["calendar::refresh"]: void;
  ["observation::deleted"]: void;
  ["draggableDialog::close"]: void;
  ["draggableDialog::refresh"]: ObjectWithId;
  ["repos::map"]: boolean;
};

const emitter = mitt<Events>();
export default emitter;
